// extracted by mini-css-extract-plugin
export default {"tableWrapper":"UserList_tableWrapper__QMawn","avatar":"UserList_avatar__xIaTp","avatarPlaceholder":"UserList_avatarPlaceholder__tx4o6"};